var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.list,"headers":_vm.header,"item-key":"name","search":_vm.searchWord,"custom-filter":_vm.filterOnlyCapsText},on:{"click:row":_vm.clickRow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }